export default "__VITE_ASSET___s3p0NTl__"